import { format, formatDistanceToNow, parseISO } from 'date-fns';

export function formatDateTime(dateStr: string | undefined): string {
  if (!dateStr) return '—';
  try {
    return format(parseISO(dateStr), 'MMM d, yyyy h:mm a');
  } catch {
    return dateStr;
  }
}

export function formatDateShort(dateStr: string | undefined): string {
  if (!dateStr) return '—';
  try {
    return format(parseISO(dateStr), 'MMM d, yyyy');
  } catch {
    return dateStr;
  }
}

export function formatTimeAgo(dateStr: string | undefined): string {
  if (!dateStr) return '—';
  try {
    return formatDistanceToNow(parseISO(dateStr), { addSuffix: true });
  } catch {
    return dateStr;
  }
}

export function formatTime(dateStr: string | undefined): string {
  if (!dateStr) return '—';
  try {
    return format(parseISO(dateStr), 'h:mm:ss a');
  } catch {
    return dateStr;
  }
}
